import { render, staticRenderFns } from "./setting-4.vue?vue&type=template&id=f2afe8fa&"
import script from "./setting-4.vue?vue&type=script&lang=js&"
export * from "./setting-4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports